module.exports = __webpack_public_path__ + "static/media/SteppingSteps-sm.7b97c001.png";